var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildBuyIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6143 2.30408C25.9547 1.00469 28.786 0.963994 31.1572 2.18201L31.3857 2.30408L49.3857 12.3031C51.9243 13.7139 53.5 16.3918 53.5 19.2953V47.0004C53.4998 51.4189 49.9186 55.0004 45.5 55.0004H9.5C5.08142 55.0004 1.50021 51.4189 1.5 47.0004V19.2953C1.5 16.4795 2.979 13.8811 5.37988 12.4388L5.61426 12.3031L23.6143 2.30408Z",
    fill: "#FFE6E6",
    stroke: "#F36A6A",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildBuyIc);
export default __webpack_public_path__ + "static/media/buildBuy_ic.1ba3593ff8b50e177fb20e88b2b65b63.svg";
export { ForwardRef as ReactComponent };